import { AlertaProduccionBanner } from '@/components/dominio/AlertaProduccionBanner';
import { ArbolVentaCosto } from '@/components/dominio/ArbolVentaCosto';
import {
  ComparativoProduccionCosto,
  type MesComparativo,
} from '@/components/dominio/ComparativoProduccionCosto';
import { Card, CardContent } from '@/components/ui/card';
import { useMensualObras } from '@/hooks/useAvanceMatriz';
import { CircleNotch } from '@phosphor-icons/react';
import { useMemo } from 'react';

/** Venta vs Costo: producción del mes contra el costo real ejecutado, por mes y obra por obra. */
export function VentaVsCostoPantalla() {
  const { data, isLoading, error } = useMensualObras();

  const comparativo = useMemo<MesComparativo[]>(() => {
    const porMes = new Map<number, MesComparativo>();
    for (const f of data?.data ?? []) {
      const k = f.anio * 100 + f.mes;
      const m = porMes.get(k) ?? { anio: f.anio, mes: f.mes, produccion: 0, costo: 0 };
      m.produccion += f.produccionMes;
      m.costo += f.costoMes ?? 0;
      porMes.set(k, m);
    }
    return [...porMes.entries()].sort((a, b) => a[0] - b[0]).map(([, m]) => m);
  }, [data]);

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 text-muted-foreground">
        <CircleNotch className="h-4 w-4 animate-spin" weight="bold" /> Cargando…
      </div>
    );
  }
  if (error) {
    return (
      <Card className="border-destructive">
        <CardContent className="pt-6">
          <p className="text-destructive">Error al cargar: {error.message}</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      <AlertaProduccionBanner />
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Venta vs Costo</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Cuánto se produce (venta) contra cuánto se invierte (costo real) mes a mes y obra por
          obra.
        </p>
      </div>
      <ComparativoProduccionCosto meses={comparativo} />
      <ArbolVentaCosto datos={data?.data ?? []} />
    </div>
  );
}
